import {fetch} from '@app/apiFunction';
import {BASE_URL} from '../config';

export const userSignup = async (data: any) => {
  const result = JSON.stringify(data);
  const token = localStorage.getItem('token');
  const type = 'post';
  const url = `${BASE_URL}/signup`;
  const payload = result;
  const resp = fetch(url, type, payload, token);
  return resp;
};

// Get all users api integrated
export const getAllUsers = async (query: any) => {
  let requestQuery = '';
  if (query) {
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(query)) {
      requestQuery = `${key}=${value}`;
    }
  }

  const token = localStorage.getItem('token');
  const type = 'get';
  const url = `${BASE_URL}/user/get-all-users?${requestQuery}`;
  const resp = fetch(url, type, null, token);
  return resp;
};

export const getUserById = async (userId: string) => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = `${BASE_URL}/user/${userId}`;
  const resp = fetch(url, type, null, token);
  return resp;
};
